import { connect, ConnectedProps } from 'react-redux'

import ContentItem from 'components/accordion/ContentItem'
import { setAccordionHighlight } from 'redux/actions'
import { AppDispatch, RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { isLogged: RootState['user']['isLogged'], highlight: RootState['accordion']['highlight'], headerHeight: RootState['layout']['headerHeight'], deviceType: RootState['layout']['deviceType'], pageId: RootState['layout']['pageId'] } => ({
  isLogged: state.user.isLogged,
  highlight: state.accordion.highlight,
  headerHeight: state.layout.headerHeight,
  deviceType: state.layout.deviceType,
  pageId: state.layout.pageId
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionHighlight: (highlight: string) => ReturnType<AppDispatch> } => ({
  setAccordionHighlight: (highlight: string) => dispatch(setAccordionHighlight(highlight))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type ContentItemContainerProps = ConnectedProps<typeof connector>

export default connect(mapStateToProps, mapDispatchToProps)(ContentItem)
